export default __webpack_public_path__ + "static/media/pictogramBeaconGroceries128.60875d68.svg";